<header class="main-header">
  <!-- Left Section -->
  <div class="header-left">
    <!-- Mobile Menu Toggle -->
    @if (isTabletOrBelow()) {
    <app-button
      variant="ghost"
      [iconOnly]="true"
      icon="menu"
      (click)="layoutService.toggleMobileMenu()"
    />
    }
    <!-- Title with Status Badge -->
    <div class="flex items-center gap-3">
      <app-heading
        [level]="isSmallDesktopOrBelow() ? 'h2' : 'h1'"
        class="page-title brand-gradient"
      >
        {{ pageTitle() || fleetName() }}
      </app-heading>

      <!-- ADD: Status Badge -->
      @if (statusBadge(); as badge) {
      <app-badge
        [variant]="badge.color"
        [title]="badge.label"
        [prefixIcon]="badge.icon"
        [size]="isTabletOrBelow() ? 'xs' : 'sm'"
      />
      }
    </div>
  </div>

  <!-- Right Section: Notifications (S3) -->
  <div class="header-right">
    <app-notification-bell placement="header" />
  </div>
</header>
